<template>
  <div class="h-100">
    <nav class="navbar navbar-expand-lg navbar-dark bg-primary" v-if="dados">
      <span class="navbar-brand"
        >Klingo - <small>{{ dados.page_title }}</small></span
      >
    </nav>
    <div class="card" v-if="parms">
      <div class="card-header alert alert-success">
        <div class="row">
          <div class="col col-12 col-md-8">
            <div class="lead mb-1">
              <strong>{{ dados.mobile_header.title }}</strong>
            </div>
            <div v-for="item in dados.mobile_header.items" :key="item.texto">
              <i class="mr-2" :class="item.icone"></i>
              {{ item.texto }}
            </div>
          </div>
        </div>
      </div>
      <div class="card-body text-center">
        <file-upload
          class="btn btn-primary btn-lg"
          post-action="https://api.klingo.app/api/upload_arquivo_token"
          extensions="gif,jpg,jpeg,png,webp,pdf"
          accept="image/png,image/gif,image/jpeg,image/webp,application/pdf"
          input-id="file"
          name="file"
          :multiple="true"
          :size="1024 * 1024 * 10 || 0"
          :custom-action="azUpload"
          v-model="files"
          @input-filter="inputFilter"
          @input-file="inputFile"
          ref="upload"
        >
          <i class="fa fa-camera mr-2"></i>
          Tirar/Selecionar foto
        </file-upload>

        <az-file-upload-items :files="files" :tipos="dados ? dados.tipo_arquivos : null" :mobile="true"></az-file-upload-items>
      </div>
      <div class="card-footer text-center">
        <button
          type="button"
          class="btn btn-success"
          v-if="!$refs.upload || !$refs.upload.active"
          @click.prevent="$refs.upload.active = true"
        >
          Enviar
        </button>
        <button
          type="button"
          class="btn btn-danger"
          v-else
          @click.prevent="$refs.upload.active = false"
        >
          <i class="fa fa-stop" aria-hidden="true"></i>
          Parar Envio
        </button>
      </div>
    </div>
    <az-empty-state :msg="status" v-else icon="fa fa-bug" />
    <div class="text-center text-muted" v-if="arquivosEnviados > 0">
      <small
        >Total de arquivos enviados:
        <strong>{{ arquivosEnviados }}</strong></small
      >
    </div>

    <Toast :baseZIndex="99999" />
  </div>
</template>

<script>
import AzEmptyState from "../util/AzEmptyState.vue";
import AzFileUploadItems from "../util/AzFileUploadItems.vue";

// import $ from "jquery";
import _ from "lodash";

export default {
  data() {
    return {
      files: [],
      status: null,
      parms: null,
      dados: null,
      arquivosEnviados: 0
    };
  },

  components: { AzEmptyState, AzFileUploadItems },

  props: ["token"],
  methods: {
    /**
     * Has changed
     * @param  Object|undefined   newFile   Read only
     * @param  Object|undefined   oldFile   Read only
     * @return undefined
     */
    inputFile: function(newFile, oldFile) {
      if (newFile && oldFile && !newFile.active && oldFile.active) {
        // Get response data
        //console.log('response', newFile.response)
        if (newFile.xhr) {
          //  Get the response status code
          console.log("status", newFile.xhr.status);
        }
      }
    },
    /**
     * Pretreatment
     * @param  Object|undefined   newFile   Read and write
     * @param  Object|undefined   oldFile   Read only
     * @param  Function           prevent   Prevent changing
     * @return undefined
     */
    inputFilter: function(newFile, oldFile, prevent) {
      if (newFile && !oldFile) {
        // Filter non-image file
        if (!/\.(jpeg|jpe|jpg|gif|png|webp|pdf)$/i.test(newFile.name)) {
          return prevent();
        }
      }

      // Create a blob field
      newFile.blob = "";
      let URL = window.URL || window.webkitURL;
      if (URL && URL.createObjectURL) {
        newFile.blob = URL.createObjectURL(newFile.file);
      }
    },
    async azUpload() {
      let formData = new FormData();

      this.$store.commit("loading", true);

      console.log(this.parms);

      if (this.parms) {
        _.forEach(this.parms, function(element, key) {
          formData.append(key, element);
        });

        formData.append("multiple", true);
        formData.append("mobile", true);
        formData.append("token", this.token);
      }

      this.files.forEach(arq => {
        const fileType = arq.file.type;
        var blob = arq.file.slice(0, arq.file.size, fileType);
        var newFile = new File([blob], arq.name, { type: fileType });

        if(arq.id_tipo_arquivo) {
            formData.append(arq.name.replace(/[\s._\-()[\]{}]/g, '').toLowerCase(), arq.id_tipo_arquivo);
        }

        formData.append("files[]", newFile);

        // formData.append("files[]", arq.file);
      });

      console.log(formData);
      return this.axios
        .post("upload_arquivo_token", formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(res => {
          console.log(res);
          if (res.response && res.response.status > 400) {
            this.$toast.add({
              severity: "error",
              summary: "Atenção",
              detail: "Erro ao enviar arquivos",
              life: 3000
            });
          } else {
            this.$nextTick(() => {
              this.arquivosEnviados += this.files.length;
              this.$toast.add({
                severity: "success",
                summary: "Atenção",
                detail: "Imagen(s) enviada(s) com sucesso.",
                life: 3000
              });
              this.files = [];
              return res;
            });
          }
        })
        .finally(() => {
          this.$store.commit("loading", true);
        });
    }
  },
  mounted() {
    this.$store.commit("loading", true);

    this.axios
      .get("/fupload/" + this.token)
      .then(res => {
        if (res.response && res.response.status > 400) {
          this.status = res.response.data;
          this.$toast.add({
            severity: "error",
            summary: "Atenção",
            detail: this.status,
            life: 3000
          });
        } else {
          this.parms = {
            model_type: res.data.model_type,
            model_id: res.data.model_id
          };
          this.dados = res.data;
        }
      })
      .catch(err => {
        alert(err);
      })
      .finally(() => {
        this.$store.commit("loading", false);
      });
  }
};
</script>
